<template>
  <a
    class="add button is-large is-warning"
    @click="$emit('click')"
  >
    <span class="icon is-medium">
      <i :class="iconClass" />
    </span>
  </a>
</template>

<script>
export default {
  props: {
    iconClass: {
      required: true,
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
.save {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// BaseActionRoundButton.vue?992fa274